import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ConsultaFormContainer from "../../../../components/ConsultaFormContainer/ConsultaFormContainer";
import Container from "../../../../components/Container/Container";
import SearchContainer from "../../../../components/SearchContainer/SearchContainer";
import SearchInput from "../../../../components/SearchInput/SearchInput";
import { useListManager } from "../../../../contexts/list.manager";
import FormGroups from "../FormGroups/FormGroups";
import ListGroups from "../ListGroups/ListGroups";
import "./ConsultaGroups.css";
import { LuUsers } from "react-icons/lu";

const ConsultaGroups = () => {
	const { lineSelected } = useListManager();
	const [searchText, setSearchText] = useState("");
	const [filters, setFilters] = useState("");
	const navigate = useNavigate();
	const location = useLocation();
	const [refreshKey, setRefreshKey] = useState(0);

	useEffect(() => {
		if (location.state?.deletedId || location.state?.refresh) {
			setRefreshKey((k) => !k);
			navigate(location.pathname, { replace: true, state: {} });
		}
	}, [location.state, navigate, location.pathname]);

	return (
		<div className="consulta-container">
			<div className="search-list-wrapper">
				<SearchContainer
					icon={<LuUsers size={20} />}
					title="Grupos"
					navigate="../cadastro-grupos"
					description="Buscar por Nome"
					buttonLabel="Adicionar Grupo"
				>
					<SearchInput
						value={searchText}
						placeholder="Buscar Grupo"
						onChange={({ target }) => setSearchText(target.value)}
						onKeyPress={(e) => e.key === "Enter" && setFilters(searchText)}
					/>
				</SearchContainer>
				<Container>
					<ListGroups
						filters={filters}
						lineSelected={lineSelected ? true : false}
						refreshKey={refreshKey}
					/>
				</Container>
			</div>
			<ConsultaFormContainer>
				<FormGroups group={lineSelected} type="consulta" />
			</ConsultaFormContainer>
		</div>
	);
};

export default ConsultaGroups;
